import FileViewer from 'react-file-viewer';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ThumbnailGrid from '../../Elements/Thumbnail/thumbnail';
import InComponentLoader from '../../Elements/Loader/componentloader';
import ButtonLoader from '../../Elements/Button/button';
//import '../../../assets/css/siicex-usuario.css';
import Checkbox from '@material-ui/core/Checkbox';

import React, { Component } from 'react';
import axios from 'axios';

import {API_URL} from '../../../constants';
import {BASE_URL_RUEDAS} from '../../../constants';
import {BASE_URL_SIICEX} from '../../../constants';
import {BASE_URL_BOLETIN} from '../../../constants';
import {CODIGO_ESTUDIOS} from '../../../constants';
import {BASE_URL_RECURSOS} from '../../../constants';
import {BASE_URL_FRONTEND} from '../../../constants';


import Error from '../../Error/error';

import {DropDownList} from '../../Elements/Select/dropdown';
import {toBase64} from '../../../functions';
import ImageUploader from 'react-images-upload';

import {deleteItemArray, updateItemArray, updateValueInJson} from '../../../functions';
import {findItemArray} from '../../../functions';
import {addItemArray} from '../../../functions';
import {updateValueInItemArray} from '../../../functions';
import {loadingButton} from '../../../functions';

import {formatLimitString} from '../../../functions';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Moment from 'moment';


import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import BulletinIcon from '@material-ui/icons/EventNote';
import SectionIcon from '@material-ui/icons/ViewComfy';
import NewsIcon from '@material-ui/icons/FiberNew';
import OportunityIcon from '@material-ui/icons/Ballot';
import MailIcon from '@material-ui/icons/Email';
import ImagenIcon from '@material-ui/icons/Image';
import TendenciasIcon from '@material-ui/icons/AssignmentTurnedIn';
import NoticiasIcon from '@material-ui/icons/FindInPage';
import OtrosIcon from '@material-ui/icons/Assessment';
import OpinionIcon from '@material-ui/icons/AssignmentInd';

import cookie from 'react-cookies';
import SeccionesBoletin from './secciones';
import renderHTML from 'react-render-html';

import {approveRole} from '../../../functions';
import Mail from '../Mail/mail';
import Mailing from '../Mail/mailing';

// Icons Mailing
const logoMail = `${BASE_URL_FRONTEND}/images/intex-logo-200px.png`;
const logoFooter = `${BASE_URL_FRONTEND}/images/logo-promperu-footer-mail.png`;
const logoFacebook = `${BASE_URL_FRONTEND}/images/rs-facebook.png`;
const logoLinkedin = `${BASE_URL_FRONTEND}/images/rs-linkedin.png`;
const logoYoutube = `${BASE_URL_FRONTEND}/images/rs-youtube.png`;
const logoTwitter = `${BASE_URL_FRONTEND}/images/rs-twitter.png`;
const imageArrow = `${BASE_URL_FRONTEND}/images/arrow-go.png`;
const imageBack = `${BASE_URL_FRONTEND}/images/last-news.jpg`;
const imageBook = `${BASE_URL_FRONTEND}/images/icono-estudios.png`;


function TabPanel(props) {
    const { children, value, index } = props;
 
    return (
        <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}>
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

function a11yProps(index) {
return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
};
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export default class edit_boletin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            resource: [],
            response: [],
            error: [],
            key: 0,
            tipoRecurso: [],
            tendencias: [],
            nuevasOportunidades: [],
            noticias: [],
            otrosSectores: [],
            casosEstudio: [],
            estudiosMercado: [],
            ocex: [],
            addOcex : [],
            addEstudiosMercado: [],
            addTendencias:[],
            addNuevasOportunidades: [],
            addNoticias: [],
            addOtrosSectores: [],
            addCasosEstudio: [],
            incrementalKey:1000,
            numeroTab:0,
            htmlMail: '<div><center><h2><p>Cargando contenido...</p></h2></center></div>',
            htmlMailTemplate: '<span></span>',
            sector: [],
            userModified: [],
            userCreated: [],
            security: cookie.load('user'),
            edit: false,
            localSecurity: [],
            generateHTML:SVGComponentTransferFunctionElement,
            fileAttach : [],
            fileTypeAttach : [],

            // Pagination handling
            pagination_data: [],
            page_show: [],
            // Image handling
            imagesToSelect: false,
            selectedImage: false,
            pagination_type: ""
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeDate = this.handleInputChangeDate.bind(this);
        // Pagination
        // this.pagination_type    = "",
        this.resultPerPage      = 6;
        // Image pagination control
        this.currentImagePage   = 1;
    }

    handleInputChangeDate(control){
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource['dFechaPublicacion'] = Moment(control).format();

         this.setState({
             resource: copyResource
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource[target.name] = value;

        this.setState({
            resource: copyResource
        });
    }

    handleInputChangeCheckbox(event, recurso, field) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let item  = findItemArray(this.state.estudiosMercado, "nRecursoCodigo", recurso)[0];
        var copyResource = updateValueInItemArray(this.state.estudiosMercado, 'nRecursoCodigo', recurso, target.name, value)


        this.setState({
            estudiosMercado: copyResource
        });
    }

    handleInputChangeCheckboxOportunidades(event, recurso, field) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let item  = findItemArray(this.state.nuevasOportunidades, "nRecursoCodigo", recurso)[0];
        var copyResource = updateValueInItemArray(this.state.nuevasOportunidades, 'nRecursoCodigo', recurso, target.name, value)


        this.setState({
            nuevasOportunidades: copyResource
        });
    }

    handleInputChangeCheckboxNoticias(event, recurso, field) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let item  = findItemArray(this.state.noticias, "nRecursoCodigo", recurso)[0];
        var copyResource = updateValueInItemArray(this.state.noticias, 'nRecursoCodigo', recurso, target.name, value)


        this.setState({
            noticias: copyResource
        });
    }


    loadTipoRecurso(sector){

        var key = this.props.location.state.key;
        var clave = 'ALL';

        if (sector===39) sector=0;

        const url = `${API_URL}BulletinResourceUX/${key}/NOTI/${sector}/true`;

        axios.get(url).then(response => response.data)
        .then((data) => {

          console.log('LOAD TIPO RECURSOS');
          console.log(data);

            this.setState({

                tipoRecurso: data.result,

                addTendencias: data.result.filter(item => {return item.cRec_Id===7 && item.bAdded===true;}),
                tendencias: data.result.filter(item => {return item.cRec_Id===7 }),

                addNuevasOportunidades: data.result.filter(item => {return item.cRec_Id===6 && item.bAdded===true;}),
                nuevasOportunidades: data.result.filter(item => {return item.cRec_Id===6}),

                addCasosEstudio: data.result.filter(item => {return item.cRec_Id===8 && item.bAdded===true;}),
                casosEstudio: data.result.filter(item => {return item.cRec_Id===8}),

                addNoticias: data.result.filter(item => {return item.cRec_Id===40 && item.bAdded===true;}),
                noticias: data.result.filter(item => {return item.cRec_Id===40}),

                addOtrosSectores: data.result.filter(item => {return item.cRec_Id===9 && item.bAdded===true;}),
                otrosSectores: data.result.filter(item => {return item.cRec_Id===9}),

                addOcex: data.result.filter(item => {return item.cRec_Id===39 && item.bAdded===true;}),
                ocex: data.result.filter(item => {return item.cRec_Id===39})

            });
        })
        .catch(error => {

            toast.error("¡Error al consultar items [Recursos en Boletín]!");
        });
    }

    componentWillMount(){
        this.getResource();
        this.getImages();
    }

    getResource(){

        console.log('security', this.state.security);

        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema === "0"; });
        var key = this.props.location.state.key;
        const url = `${API_URL}BulletinUX/${key}/0`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            console.log(data);

            // Carga de Recursos ya asignados al boletin
            var flag = approveRole(roles, this.state.security.Tusu_EsSuperAdmin) || data.result.cEstado === 'B';
            //this.formatHTMLtoMail(html, data.result);

            this.setState({ 
                edit: !flag, 
                roles :roles, 
                resource:data.result, 
                response:data, 
                error: data.Error 
            }, ()=> {
                this.loadTipoRecurso(data.result.nSectorCodigo);
                this.loadSector(data.result.nSectorCodigo);
            });

            axios.get(`${API_URL}SecurityUX/${data.result.nUsuarioModificacion}/ /1`)
            .then(response => response.data)
            .then((dataResult) => {
                    this.setState({userModified: dataResult.result} );
            });

            axios.get(`${API_URL}SecurityUX/${data.result.nUsuarioCreacion}/ /1`)
            .then(response => response.data)
            .then((dataResult) => {
                    this.setState({userCreated: dataResult.result} );
            });

            if(document.querySelector('.loader')){
                document.querySelector('.loader').classList.add('loader--hide');
            }
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            if(document.querySelector('.loader')){
                document.querySelector('.loader').classList.add('loader--hide');
            }
            toast.error("¡Error al consultar items!");
        });
    }

    loadSector=(type) => {

        const url = `${API_URL}MasterUX/${type}/1/1/`; //
        axios.get(url).then(response => response.data)
        .then((data) => {
            this.setState({ sector: data.result, response: data, error: data.Error });
        })
        .catch(error => {
        });

    }

    handleClickCancel(e) {
        const {history: {push}} = this.props;
        push('/boletin');
    }

    callFunctionButton = (event) => {
        event.preventDefault();

        const {history: {push}} = this.props;
        const url = `${API_URL}BulletinUX/`;

        var nSectorCodigo = this.state.resource.nSectorCodigo;

        var dataToSave = this.state.resource;

        dataToSave  = updateValueInJson(dataToSave, 'nUsuarioModificacion', this.state.security.nUsuCodigo);
        dataToSave  = updateValueInJson(dataToSave,'Bole_NotificarPorPush', (this.state.resource.bole_NotificarPorPush.value ? this.state.resource.bole_NotificarPorPush.value : this.state.resource.bole_NotificarPorPush));

        if (this.state.resource.bActivo.value === undefined){
            dataToSave = updateValueInJson(dataToSave,'bActivo', this.state.resource.bActivo);
        }else{
            dataToSave = updateValueInJson(dataToSave,'bActivo', this.state.resource.bActivo.value);
        }

        if (this.state.resource.cEstado.value === undefined){
            dataToSave = updateValueInJson(dataToSave,'cEstado', this.state.resource.cEstado);
        }else{
            dataToSave = updateValueInJson(dataToSave,'cEstado', this.state.resource.cEstado.value);
        }

        if (nSectorCodigo.value === undefined){
            dataToSave = updateValueInJson(dataToSave,'nSectorCodigo', this.state.resource.nSectorCodigo);
            dataToSave = updateValueInJson(dataToSave,'sSector', this.state.resource.sSector);
            dataToSave = updateValueInJson(dataToSave,'sDescripcionSector', this.state.resource.sSector);
        }else{
            dataToSave = updateValueInJson(dataToSave,'nSectorCodigo', nSectorCodigo.value);
            dataToSave = updateValueInJson(dataToSave,'sSector', nSectorCodigo.label);
            dataToSave = updateValueInJson(dataToSave,'sDescripcionSector', nSectorCodigo.label);
        }

        
        this.setState({
            loading:true
        });
        
        const formData = JSON.stringify(dataToSave);
        // console.log(dataToSave);

        axios.put(
            url,
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
        ).then(
            (data)=> {

                if(document.querySelector('.loader')){
                    document.querySelector('.loader').classList.add('loader--hide');
                }
                document.getElementById('content-wrapper').removeAttribute("hidden");

                if (data.data.isSucess){
                    toast.success('Boletín editado correctamente. \n Se redireccionará al listado');
                    setTimeout(() => {
                         push('/boletin');
                    }, 1000);
                } else{
                    this.setState({
                        loading:false
                    });
                    toast.error('No se pudo editar el Boletín. \r');
                }
            }
        ).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
        });
        
        
    }

    saveBulletinResources =  async(nRecursoCodigo, sRecursoTipo, bNoticiaPrincipalEmail, bNoticiaSecundariaEmail, bOportunidadEmail, bEstudiosEmail) =>{
        const url = `${API_URL}BulletinResourceUX/`;
        var key = this.props.location.state.key;
        var formData = JSON.stringify(
            {
                nBoletinCodigo: key,
                nRecursoCodigo: nRecursoCodigo,
                nRecursoTipo:sRecursoTipo,
                nUsuarioCreacion: this.state.security.nUsuCodigo,
                nSectorCodigo: 0,
                sSector: '',
                bPortada: false,
                bNoticiaPrincipalEmail: bNoticiaPrincipalEmail,
                bNoticiaSecundariaEmail: bNoticiaSecundariaEmail,
                bOportunidadEmail: bOportunidadEmail,
                bEstudiosEmail: bEstudiosEmail
            }
        );
        var returnValue;
        await axios.post(
            url,
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {
                    returnValue = data.data;
                }
            ).catch((error)=> {
                toast.error('Error no controlado.');
            });
        return returnValue;
    }

    deleteBulletinResources = async(code) =>
    {
        var key = this.props.location.state.key;
        const url = `${API_URL}BulletinResourceUX/${key}/${code}`;
        var returnValue;
        await axios.delete(
            url,
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {
                    returnValue=data.data;
                }
            ).catch((error)=> {
                throw error;
            });
        return returnValue;
    }

    handleDeleteTrend = async(key, keyResource, button) =>
    {
        loadingButton(button, "fa-trash");
        var ResourceKey = 0;

        let item  = findItemArray(this.state.tendencias, "nRecursoCodigo", keyResource)[0];
        if (item!==undefined)
        {
            item.bAdded = false;
            ResourceKey = item.nRecursoCodigo;
        }
        else
        {
            ResourceKey= keyResource;
        }

        this.deleteBulletinResources(ResourceKey)
            .then(
                (data)=>{
                        if (data.isSucess)
                        {

                            this.setState({ addTendencias : deleteItemArray(this.state.addTendencias, "nBoletinRecursoCodigo", key)});
                            if (item!==undefined) {
                                this.setState({tendencias:  updateItemArray(this.state.tendencias,  "nRecursoCodigo", keyResource, item)});
                            }
                            //this.formatHTMLtoMail(this.state.htmlMailTemplate, this.state.resource);
                        }
                    });
    }

    handleAddTrend = async(key) =>
    {
        loadingButton(key, "fa-plus");

        let item  = findItemArray(this.state.tendencias, "nRecursoCodigo", key)[0];

        this.saveBulletinResources(item.nRecursoCodigo, item.sCodigo, false, false, false, false)
        .then(
            (data) =>
            {
                if (data.isSucess)
                    {
                        this.setState({incrementalKey: this.state.incrementalKey+1});
                        this.setState({tendencias:  updateValueInItemArray(this.state.tendencias, "nRecursoCodigo", item.nRecursoCodigo, "bAdded", true)});
                        let itemToAdd = { nRecursoTipo:'TEND', bAdded:true, nBoletinRecursoCodigo: this.state.incrementalKey, nBoletinCodigo: this.props.location.state.key, nRecursoCodigo: item.nRecursoCodigo, sTituloRecurso: item.sTituloRecurso, sTituloBoletin: '' };
                        this.setState({addTendencias:  addItemArray(this.state.addTendencias, itemToAdd)});
                        //this.formatHTMLtoMail(this.state.htmlMailTemplate,this.state.resource);
                    }
            }
        );
    }

    handleAddOcex = async(key)=>
    {
        loadingButton(key, "fa-plus");

        let item  = findItemArray(this.state.ocex, "nRecursoCodigo", key)[0];

        this.saveBulletinResources(item.nRecursoCodigo, item.sCodigo, false, false, false, false)
        .then(
            (data) =>
            {
                if (data.isSucess)
                    {
                        this.setState({incrementalKey: this.state.incrementalKey+1});
                        this.setState({ocex:  updateValueInItemArray(this.state.ocex, "nRecursoCodigo", item.nRecursoCodigo, "bAdded", true)});
                        let itemToAdd = { nRecursoTipo:'OCEX', bAdded:true, nBoletinRecursoCodigo: this.state.incrementalKey, nBoletinCodigo: this.props.location.state.key, nRecursoCodigo: item.nRecursoCodigo, sTituloRecurso: item.sTituloRecurso, sTituloBoletin: '' };
                        this.setState({addOcex:  addItemArray(this.state.addOcex, itemToAdd)});
                    }
            }
        );
    }

    handleDeleteOcex = async(key, keyResource, button) =>
    {
        loadingButton(button, "fa-trash");
        var ResourceKey = 0;

        let item  = findItemArray(this.state.ocex, "nRecursoCodigo", keyResource)[0];
        if (item!==undefined)
        {
            item.bAdded = false;
            ResourceKey = item.nRecursoCodigo;
        }
        else
        {
            ResourceKey= keyResource;
        }

        this.deleteBulletinResources(ResourceKey)
            .then(
                (data)=>{
                        if (data.isSucess)
                        {

                            this.setState({ addOcex : deleteItemArray(this.state.addOcex, "nBoletinRecursoCodigo", key)});
                            if (item!==undefined) {
                                this.setState({ ocex:  updateItemArray(this.state.ocex,  "nRecursoCodigo", keyResource, item)});
                            }
                        }
                    });
    }
    
    
    handleDeleteCases = async(key, keyResource, button) =>
    {
        loadingButton(button, "fa-trash");
        var ResourceKey = 0;

        let item  = findItemArray(this.state.casosEstudio, "nRecursoCodigo", keyResource)[0];
        if (item!==undefined)
        {
            item.bAdded = false;
            ResourceKey = item.nRecursoCodigo;
        }
        else
        {
            ResourceKey= keyResource;
        }

        this.deleteBulletinResources(ResourceKey)
            .then(
                (data)=>{
                        if (data.isSucess)
                        {

                            this.setState({ addCasosEstudio : deleteItemArray(this.state.addCasosEstudio, "nBoletinRecursoCodigo", key)});
                            if (item!==undefined) {
                                this.setState({casosEstudio:  updateItemArray(this.state.casosEstudio,  "nRecursoCodigo", keyResource, item)});
                            }
                            //this.formatHTMLtoMail(this.state.htmlMailTemplate,this.state.resource);
                        }
                    });
    }

    handleAddCases = async(key) =>
    {
        loadingButton(key, "fa-plus");
        let item  = findItemArray(this.state.casosEstudio, "nRecursoCodigo", key)[0];
        this.saveBulletinResources(item.nRecursoCodigo, item.sCodigo, false, false, false, false)
        .then(
            (data) =>
            {
                if (data.isSucess)
                    {
                        this.setState({incrementalKey: this.state.incrementalKey+1});
                        this.setState({casosEstudio:  updateValueInItemArray(this.state.casosEstudio, "nRecursoCodigo", item.nRecursoCodigo, "bAdded", true)});
                        let itemToAdd = { nRecursoTipo:'CASE', bAdded:true, nBoletinRecursoCodigo: this.state.incrementalKey, nBoletinCodigo: this.props.location.state.key, nRecursoCodigo: item.nRecursoCodigo, sTituloRecurso: item.sTituloRecurso, sTituloBoletin: '' };
                        this.setState({addCasosEstudio:  addItemArray(this.state.addCasosEstudio, itemToAdd)});
                        //this.formatHTMLtoMail(this.state.htmlMailTemplate,this.state.resource);
                    }
            }
        );
    }

    handleAddSector = async(key) =>
    {
        loadingButton(key, "fa-plus");
        let item  = findItemArray(this.state.otrosSectores, "nRecursoCodigo", key)[0];
        this.saveBulletinResources(item.nRecursoCodigo, item.sCodigo, false, false, false, false)
        .then(
            (data) =>
            {
                if (data.isSucess)
                    {
                        this.setState({incrementalKey: this.state.incrementalKey+1});
                        this.setState({otrosSectores:  updateValueInItemArray(this.state.otrosSectores, "nRecursoCodigo", item.nRecursoCodigo, "bAdded", true)});
                        let itemToAdd = { nRecursoTipo:'SETI', bAdded:true, nBoletinRecursoCodigo: this.state.incrementalKey, nBoletinCodigo: this.props.location.state.key, nRecursoCodigo: item.nRecursoCodigo, sTituloRecurso: item.sTituloRecurso, sTituloBoletin: '' };
                        this.setState({addOtrosSectores:  addItemArray(this.state.addOtrosSectores, itemToAdd)});
                        //this.formatHTMLtoMail(this.state.htmlMailTemplate,this.state.resource);
                    }
            }
        );
    }

    handleDeleteSectors = async(key, keyResource, button) =>
    {
        loadingButton(button, "fa-trash");
        var ResourceKey = 0;

        let item  = findItemArray(this.state.otrosSectores, "nRecursoCodigo", keyResource)[0];
        if (item!==undefined)
        {
            item.bAdded = false;
            ResourceKey = item.nRecursoCodigo;
        }
        else
        {
            ResourceKey= keyResource;
        }

        this.deleteBulletinResources(ResourceKey)
            .then(
                (data)=>{
                        if (data.isSucess)
                        {
                            this.setState({ addOtrosSectores : deleteItemArray(this.state.addOtrosSectores, "nBoletinRecursoCodigo", key)});
                            if (item!==undefined) {
                                this.setState({otrosSectores:  updateItemArray(this.state.otrosSectores,  "nRecursoCodigo", keyResource, item)});
                            }
                            //this.formatHTMLtoMail(this.state.htmlMailTemplate,this.state.resource);
                        }
                    });
    }

    handleAddNews = async(key) =>
    {
        loadingButton(key, "fa-plus");
        let item  = findItemArray(this.state.noticias, "nRecursoCodigo", key)[0];
        this.saveBulletinResources(item.nRecursoCodigo, item.sCodigo, item.bNoticiaPrincipalEmail, item.bNoticiaSecundariaEmail, false, false)
        .then(
            (data) =>
            {
                if (data.isSucess)
                    {
                        this.setState({incrementalKey: this.state.incrementalKey+1});
                        this.setState({noticias:  updateValueInItemArray(this.state.noticias, "nRecursoCodigo", item.nRecursoCodigo, "bAdded", true)});
                        let itemToAdd = { bNoticiaPrincipalEmail: item.bNoticiaPrincipalEmail, bNoticiaSecundariaEmail:item.bNoticiaSecundariaEmail,  nRecursoTipo:'NOTI', bAdded:true, nBoletinRecursoCodigo: this.state.incrementalKey, nBoletinCodigo: this.props.location.state.key, nRecursoCodigo: item.nRecursoCodigo, sTituloRecurso: item.sTituloRecurso, sTituloBoletin: '' };
                        this.setState({addNoticias:  addItemArray(this.state.addNoticias, itemToAdd)});
                    }
            }
        );
    }

    handleDeleteNews = async(key, keyResource, button) =>
    {
        loadingButton(button, "fa-trash");
        var ResourceKey = 0;

        let item  = findItemArray(this.state.noticias, "nRecursoCodigo", keyResource)[0];

        if (item!==undefined)
        {
            item.bAdded = false;
            ResourceKey = item.nRecursoCodigo;
        }
        else
        {
            ResourceKey= keyResource;
        }


         this.deleteBulletinResources(ResourceKey)
            .then(
                (data)=>{
                        if (data.isSucess)
                        {
                            this.setState({ addNoticias : deleteItemArray(this.state.addNoticias, "nBoletinRecursoCodigo", key)});
                            if (item!==undefined) {
                                this.setState({noticias:  updateItemArray(this.state.noticias,  "nRecursoCodigo", keyResource, item)});
                            }
                            //this.formatHTMLtoMail(this.state.htmlMailTemplate,this.state.resource);
                        }
                    });
    }


    handleAddStudy = async(key) =>
    {
        loadingButton(key, "fa-plus");
        let item  = findItemArray(this.state.estudiosMercado, "nRecursoCodigo", key)[0];

        this.saveBulletinResources(item.nRecursoCodigo, item.sCodigo, false, false, false, item.bEstudiosEmail)
        .then(
            (data) =>
            {
                if (data.isSucess)
                    {
                        this.setState({incrementalKey: this.state.incrementalKey+1});
                        this.setState({estudiosMercado:  updateValueInItemArray(this.state.estudiosMercado, "nRecursoCodigo", item.nRecursoCodigo, "bAdded", true)});
                        let itemToAdd = { bEstudiosEmail: item.bEstudiosEmail, nRecursoTipo:'EMER', bAdded:true, nBoletinRecursoCodigo: this.state.incrementalKey, nBoletinCodigo: this.props.location.state.key, nRecursoCodigo: item.nRecursoCodigo, sTituloRecurso: item.sTituloRecurso, sTituloBoletin: '' };
                        this.setState({addEstudiosMercado:  addItemArray(this.state.addEstudiosMercado, itemToAdd)});
                    }
            }
        );
    }

    handleDeleteStudy = async(key, keyResource, button) =>
    {
        var ResourceKey = 0;
        loadingButton(button, "fa-trash");

        let item  = findItemArray(this.state.estudiosMercado, "nRecursoCodigo", keyResource)[0];

        if (item!==undefined)
        {
            item.bAdded = false;
            ResourceKey = item.nRecursoCodigo;
        }
        else
        {
            ResourceKey= keyResource;
        }

        this.deleteBulletinResources(ResourceKey)
            .then(
                (data)=>{
                        if (data.isSucess)
                        {
                            this.setState({ addEstudiosMercado : deleteItemArray(this.state.addEstudiosMercado, "nBoletinRecursoCodigo", key)});
                            if (item!==undefined) {
                                this.setState({estudiosMercado:  updateItemArray(this.state.estudiosMercado,  "nRecursoCodigo", keyResource, item)});
                            }
                            //this.formatHTMLtoMail(this.state.htmlMailTemplate,this.state.resource);
                        }
                    });
    }


    handleAddOportunity = async(key) =>
    {
        loadingButton(key, "fa-plus");
        let item  = findItemArray(this.state.nuevasOportunidades, "nRecursoCodigo", key)[0];
        this.saveBulletinResources(item.nRecursoCodigo, item.sCodigo, false, false, item.bOportunidadEmail, false)
        .then(
            (data) =>
            {
                if (data.isSucess)
                    {
                        this.setState({incrementalKey: this.state.incrementalKey+1});
                        this.setState({nuevasOportunidades:  updateValueInItemArray(this.state.nuevasOportunidades, "nRecursoCodigo", item.nRecursoCodigo, "bAdded", true)});
                        let itemToAdd = { bOportunidadEmail: item.bOportunidadEmail, nRecursoTipo:'NVOP', bAdded:true, nBoletinRecursoCodigo: this.state.incrementalKey, nBoletinCodigo: this.props.location.state.key, nRecursoCodigo: item.nRecursoCodigo, sTituloRecurso: item.sTituloRecurso, sTituloBoletin: '' };
                        this.setState({addNuevasOportunidades:  addItemArray(this.state.addNuevasOportunidades, itemToAdd)});
                    }
            }
        );
    }

    handleDeleteOportunity = async(key, keyResource, button) =>
    {
        var ResourceKey = 0;
        loadingButton(button, "fa-trash");

        let item  = findItemArray(this.state.nuevasOportunidades, "nRecursoCodigo", keyResource)[0];

        if (item!==undefined)
        {
            item.bAdded = false;
            ResourceKey = item.nRecursoCodigo;
        }
        else
        {
            ResourceKey= keyResource;
        }

        this.deleteBulletinResources(ResourceKey)
            .then(
                (data)=>{
                        if (data.isSucess)
                        {
                            this.setState({ addNuevasOportunidades : deleteItemArray(this.state.addNuevasOportunidades, "nBoletinRecursoCodigo", key)});
                            if (item!==undefined) {
                                this.setState({nuevasOportunidades:  updateItemArray(this.state.nuevasOportunidades,  "nRecursoCodigo", keyResource, item)});
                            }
                            //this.formatHTMLtoMail(this.state.htmlMailTemplate,this.state.resource);
                        }
                    });
    }


    handleChangeTab = (event, newValue) => {
        this.setState({numeroTab: newValue});
    };

    useStyles = makeStyles(theme => ({
        root: {
          flexGrow: 1,
          backgroundColor: theme.palette.background.paper,
        },
    }));

    handleDownload()
    {
        window["downloadHTML"]();
    }

    handleDownloadPdf()
    {
        window["downloadPDF"]();
    }

    onDrop=(picture)=>{
      if(picture.length<1) return;
      var file = picture[0];
      toBase64(file).catch(e => e).then(
        (data)=>
        {
          // Save as temp in state
          let _tmp = file
          _tmp.base64 = data;
          this.setState({selectedImage: _tmp});
        }
      );
    }

    onDropFile=(file)=>{
        var index = file.length;
        if (index===0) return;
        var fileItem = file[index-1];

        var name =fileItem.name;
        var size = (fileItem.size/1024).toFixed(2) + ' Kb';
        var extension = fileItem.type;

        document.getElementById('divFileName').innerHTML = 'Archivo a subir: ' + name;

        toBase64(fileItem).catch(e => e).then(
            (data)=>
            {
                this.setState({ fileAttach: data, fileTypeAttach: extension });
                // this.setState({resource:  updateValueInJson(this.state.resource, "sRuta", fileItem.name)});
                // this.setState({resource:  updateValueInJson(this.state.resource, "sExtension", fileItem.type)});
                // this.setState({resource:  updateValueInJson(this.state.resource, "fArchivo", data)});
            }
        );
    }


    // PAGINATION
    // Get pagination data
    getPaginationDataByType(type){
      let data = false;
      switch(type){
        case "oportunidades": data = this.state.nuevasOportunidades; break;
        case "tendencias": data = this.state.tendencias; break;
        case "noticias": data = this.state.noticias; break;
        case "otrossectores": data = this.state.otrosSectores; break;
        case "estudios": data = this.state.estudiosMercado; break;
        case "opinion": data = this.state.casosEstudio; break;
        case "ocex": data = this.state.ocex; break;
        default: break;
      }
      return data;
    }
    // Change page
    executePagination(type, page=1, limit=this.resultPerPage, pass=true){
      // console.log("EXEC PAG", this.state.pagination_data, this.state.page_show);
      // Set data to be rendered
      if(this.state.pagination_data.length==0 || this.state.pagination_type != type){
        // Get data
        let data = this.getPaginationDataByType(type);
        if(!pass){
            this.setState({page_show: []});
            return;
        }

        this.state.pagination_type = type;
        this.setState({pagination_data: data}, () => {
          // Execute function with same parameters
          this.executePagination(type, page, limit, false);
        });
        return;
      }
      let data = this.state.pagination_data;

      // Pagination handling
      let totalPages = Math.ceil(data.length/limit);

      for(let index=1; index<(totalPages+1); index++)
        if(document.getElementById(type+"-"+index))
          document.getElementById(type+"-"+index).classList.remove("active");

      document.getElementById(type+"-"+page).classList.add("active");

      // Set data to be rendered
      this.setState({ page_show: data.slice((page-1)*limit, (page*limit)-1) });
    }
    // Add pagination DOM
    paginationTable(type, limit=this.resultPerPage){
      // Get data
      let data = this.state.pagination_data.length!=0 ? this.state.pagination_data : false;
      if(!data){
        data = this.getPaginationDataByType(type);
        if(!data || data.length==0) return;
      }

      // Pagination calcs
      let totalPages = Math.ceil(data.length/limit);
      let options = false;
      options = [];
      // Inicio button
      if(totalPages>2) options.push(<span id={type+"-inicio"} key={type+"pagination-inicio"} onClick={() => this.executePagination(type, 1, limit)}>Inicio </span>);
      // Index buttons
      for(let index=1; index<(totalPages+1); index++){
        if(index>10 && index%10!=0) continue;
        options.push(<span id={type+"-"+index} key={type+"pagination-link-"+index} onClick={() => this.executePagination(type, index, limit)}> {index} </span>);
      }
      // Fin button
      if(totalPages>2) options.push(<span id={type+"-fin"} key={type+"pagination-fin"} onClick={() => this.executePagination(type, totalPages, limit)}>Fin </span>);

      return (
        <div className="pagination" key={type+"_pagination"}>
          {options}
        </div>
      );
    }
    // Search in pagination function handling
    searchInPagination(type){
      let keyword = document.querySelector(`#${type}-pagination-search`).value;
      if(keyword.length==0){
        this.setState({pagination_data: []}, () => {
          this.executePagination(type);
        });
        return;
      }

      // Get data
      let data = this.getPaginationDataByType(type);
      if(!data || data.length==0) return;

      // Data handling
      let _new_data = data.filter(item => {
        return item.sTituloRecurso.toLowerCase().indexOf(keyword.toLowerCase()) != -1
      });

      this.setState({pagination_data: _new_data}, () => {
        if(false) return;  // Remove toast
        if(this.state.pagination_data.length>0)
          toast.success(this.state.pagination_data.length+' resultados encontrados');
        else
          toast.error('No se encontraron resultados');
        this.executePagination(type);
      });
    }
    // Start pagination && update this.state.resource
    startPaginationClick(type){
        this.executePagination(type);
        this.getResource();
    }

    // IMAGEN
    getImages(page=1){
      const urlBase  = `${API_URL}`
      axios.get(urlBase + `FileUX/0/${page}/imagenes/all/all`).then(response => response.data)
      .then((data) => {
        this.currentImagePage = page
        this.setState({ imagesToSelect: data.result});
      }).catch(error => {
        console.error(error);
      });
    }
    selectImage = (img_obj) => {
      // Set this.state properties
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sFondo', img_obj.sArchivoRuta)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', img_obj.nArchivoCodigo)
      this.setState({resource: _tmp}, () => {
        document.getElementById("thumbnail-modal-close").click();
      });
    }
    unSelectImage = () => {
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sFondo', null)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', null)
      this.setState({resource: _tmp});
    }
    uploadImage = () => {
      let _file = this.state.selectedImage;
      let formData = {};
      let _filename = _file.name
      formData.sArchivoNombre = _filename;
      formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16"
      formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".")+1, _filename.length)
      formData.sArchivoTipo = "imagenes"
      //formData.sCategoriaArchivo = "boletin"
      formData.sCategoriaArchivo = ""
      formData.sArchivoData = _file.base64;
      formData.nCodigoUsuario = this.state.security.nUsuCodigo;

      toast.info("Por favor espere mientras la imagen es procesada")
      axios.post((API_URL+`FileUX/`),
        ("'"+JSON.stringify(formData)+"'"),
        {
          headers: {
            'Content-Type': 'application/json; charset=UTF-8' ,
            'Accept': 'application/json'
          }
        }
      ).then( data => {
        toast.success("La imagen ha sido subida correctamente")

        // Select uploaded image
        let _tmp = {};
        _tmp = updateValueInJson(this.state.resource, 'sFondo', data.data.result.sArchivoRuta)
        _tmp = updateValueInJson(_tmp, 'nImagenCodigo', data.data.result.nArchivoCodigo)
        this.setState({resource: _tmp}, this.getImages());
      }).catch((error)=> {
        console.error(error);
        toast.error('Error al subir la imagen');
      });
    }
    imagePaginationTable(){
      // Get data
      let data = this.state.imagesToSelect.length!=0 ? this.state.imagesToSelect : false;
      if(!data){
        data = this.state.imagesToSelect;
        if(!data || data.length==0) return;
      }

      // Pagination calcs
      let totalPages = data[0].totalPages;
      let options = false;
      options = [];

      // Inicio button
      if(totalPages>2) options.push(<span id={"pagination-inicio"} key={"pagination-inicio"} onClick={() => this.getImages(1)}>Inicio </span>);
      // Index buttons
      for(let index=1; index<(totalPages+1); index++){
        if(index>10 && index%10!=0) continue;
        options.push(
          <span id={"pagination-"+index}
            key={"pagination-link-"+index}
            onClick={() => this.getImages(index)}
            className={index===this.currentImagePage?"active":""}>
              {index}
          </span>
        );
      }
      // Fin button
      if(totalPages>2) options.push(<span id={"pagination-fin"} key={"pagination-fin"} onClick={() => this.getImages(totalPages)}>Fin </span>);

      return (
        <div className="pagination" key={"pagination"}>
          {options}
        </div>
      );
    }


    componentDidUpdate(prevProps, prevState){
        // Clear pagination search box
        if(this.state.pagination_data.length==0){
            document.querySelectorAll(`input[data-type=search]`).forEach(el => {el.value=""});
        }
        // Fix outdated pagination_data
        if(
            this.state.pagination_data !=
            this.getPaginationDataByType(this.state.pagination_type)
        ){
            this.setState(
                {pagination_data: this.getPaginationDataByType(this.state.pagination_type)},
                () => {this.executePagination(this.state.pagination_type)}
            )
        }
    }

    render(){

        //console.log(this.state);

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });
        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
                (this.state.response.statusCode==200)?
                (
                    <div id="detailBody" className="Site-content" >

                        <div className="loader"></div>
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >
                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={this.state.resource.nUsuarioModificacion} />
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                    <div className="content-option">
                                        <div className={this.useStyles.root}>
                                            <AppBar position="static" color="default" >
                                                <Tabs value={this.state.numeroTab} onChange={this.handleChangeTab}
                                                scrollButtons="auto"
                                                aria-label="icon label tabs example"
                                                variant="fullWidth"
                                                indicatorColor="secondary"
                                                textColor="secondary">
                                                    <Tab icon={<BulletinIcon />} label="Boletín" {...a11yProps(0)} />
                                                    <Tab icon={<ImagenIcon />} label="Imagen" {...a11yProps(1)} />
                                                    <Tab icon={<SectionIcon />} label="Secciones" {...a11yProps(2)} />
                                                    <Tab icon={<NewsIcon />}  label="Oportunidades" {...a11yProps(3)} />
                                                    <Tab icon={<TendenciasIcon />}  label="Tendencias" {...a11yProps(4)} />
                                                    <Tab icon={<NoticiasIcon />}  label="Noticias" {...a11yProps(5)} />
                                                    <Tab icon={<OtrosIcon />}  label="Otros Sectores" {...a11yProps(6)} />
                                                    <Tab icon={<OpinionIcon />}  label="Opinion" {...a11yProps(7)} />
                                                    <Tab hidden={true} icon={<OportunityIcon />}  label="Estudios" {...a11yProps(8)} />
                                                    <Tab icon={<OportunityIcon />}  label="OCER" {...a11yProps(9)} />
                                                    <Tab icon={<MailIcon />}  label="Mail" {...a11yProps(10)} />
                                                </Tabs>
                                            </AppBar>

                                            <TabPanel value={this.state.numeroTab} index={0}>
                                                <div className="row ">
                                                    <div className="col-md-6">
                                                        <div className="boletin__filters section__margin-bottom">
                                                            <div className="form-group">
                                                                <label htmlFor="nBoletinCodigo"><strong>Código</strong></label>
                                                                <input type="text" readOnly name="nBoletinCodigo" onChange={this.handleInputChange} id="nBoletinCodigo" defaultValue={this.state.resource.nBoletinCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="nSectorCodigo"><strong>Sector</strong></label>
                                                                <div className="col-sm-12">
                                                                    <DropDownList 
                                                                        tipo={"master"} 
                                                                        metodo={"edit"}  
                                                                        filtro={this.state.roles} 
                                                                        superAdmin={this.state.security.Tusu_EsSuperAdmin}
                                                                        name="nSectorCodigo" 
                                                                        valor={this.state.resource.nSectorCodigo} 
                                                                        onChange={this.handleInputChange} 
                                                                        id="nSectorCodigo" 
                                                                        clave={this.state.resource.nSectorCodigo}
                                                                        componente={"Sector"} 
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="sTitulo"><strong>Título</strong></label>
                                                                <input 
                                                                    type="text" 
                                                                    name="sTitulo" 
                                                                    id="sTitulo" 
                                                                    onChange={this.handleInputChange} 
                                                                    defaultValue={this.state.resource.sTitulo} 
                                                                    className="form-control text-filter__form-control" 
                                                                    placeholder="Título" 
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="sDescripcion"><strong>Descripcion</strong></label>
                                                                <input type="text" name="sDescripcion" id="sDescripcion" onChange={this.handleInputChange} defaultValue={this.state.resource.sDescripcion} className="form-control text-filter__form-control" placeholder="Descripcion" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label ><strong>Fecha de Publicación</strong></label>
                                                                <br/>
                                                                <DatePicker
                                                                  className="form-control text-filter__form-control col-md-12"
                                                                  onChange={this.handleInputChangeDate}
                                                                  value={Moment(this.state.resource.dFechaPublicacion).format('dddd DD, MMMM YYYY')}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                                <div className="">
                                                                    <DropDownList 
                                                                        filtro={this.state.roles} 
                                                                        superAdmin={this.state.security.Tusu_EsSuperAdmin}
                                                                        metodo={"edit"} 
                                                                        name="cEstado" 
                                                                        valor={this.state.resource.cEstado}  
                                                                        id="cEstado" 
                                                                        onChange={this.handleInputChange} 
                                                                        clave={this.state.resource.cEstado} 
                                                                        componente={"EstadoBoletin"} 
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="bActivo"><strong>Activo</strong></label>
                                                                <div className="">
                                                                    <DropDownList 
                                                                        className="form-control text-filter__form-control" 
                                                                        valor={this.state.resource.bActivo} 
                                                                        name="bActivo" 
                                                                        id="bActivo" 
                                                                        onChange={this.handleInputChange} 
                                                                        clave={this.state.resource.bActivo} 
                                                                        componente={"Activo"} 
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                            <div className="bole_NotificarPorPush">
                                                                    <Checkbox  
                                                                        name="bole_NotificarPorPush" 
                                                                        id="bole_NotificarPorPush" 
                                                                        onChange={this.handleInputChange} 
                                                                        // value={this.state.resource.bole_NotificarPorPush} 
                                                                        placeholder="Notificar por push" 
                                                                        checked={this.state.resource.bole_NotificarPorPush}
                                                                    />
                                                                    <label htmlFor="bole_NotificarPorPush">
                                                                        <strong>Notificar por push</strong>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                    </div>
                                                    <div className="col-md-6">
                                                        <br/>
                                                        <br/>
                                                        <a className="text-danger" href={BASE_URL_BOLETIN + '/' + this.state.resource.nBoletinCodigo} target="_blank">
                                                            <strong>Revisar aquí el Boletín terminado N° {this.state.resource.nBoletinCodigo}</strong>
                                                        </a>
                                                        <strong><hr/></strong>
                                                        <strong>NÚMERO DE VISTAS:</strong> {this.state.resource.nVistas}
                                                        <br/>
                                                        <strong>NÚMERO DE DESCARGAS:</strong> {this.state.resource.nDescargas}
                                                        <br/>
                                                        <br/>
                                                        <strong>FECHA DE CREACIÓN:</strong>  {Moment(this.state.resource.dFechaCreacion).format('dddd DD, MMMM YYYY')}
                                                        <br/>
                                                        <strong>CREADO POR</strong> : {this.state.userCreated ? this.state.userCreated.sUsuNombre : ""} {this.state.userCreated ? this.state.userCreated.sUsuApellidoPaterno : ""}
                                                        <br/><br/>
                                                        <strong>FECHA DE MODIFICACIÓN:</strong> {Moment(this.state.resource.dFechaModificacion).format('dddd DD, MMMM YYYY')}
                                                        <br/>
                                                        <strong>MODIFICADO POR:</strong> {(this.state.userModified && typeof this.state.userModified === "object") && this.state.userModified.sUsuNombre} {(this.state.userModified && typeof this.state.userModified === "object") && this.state.userModified.sUsuApellidoPaterno}
                                                        <br/>
                                                        <br/>
                                                        <div className="row">
                                                            <div className="col-md-12" hidden={true}>
                                                                <h5 className="text-danger"><strong>Resumen de Boletín</strong></h5>
                                                                <ul type="a">
                                                                    <li className="text-danger" hidden={false}>  all</li>
                                                                    <li className="text-danger" hidden={(this.state.resource.sFondo?true:false)}> No se ha escodigo una imagen de fondo</li>
                                                                    <li className="text-danger" hidden={false}> No ha configurado ninguna sección en el Boletín</li>
                                                                    <li className="text-danger" hidden={false}> tres</li>
                                                                    <li className="text-danger" hidden={false}> cuatro</li>
                                                                    <li className="text-danger" hidden={false}> cinco</li>
                                                                    <li className="text-danger" hidden={false}> seis</li>
                                                                    <li className="text-danger" hidden={false}> siete</li>
                                                                    <li className="text-danger" hidden={false}> ocho</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <br/>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <button type="button" onClick={(event) => this.handleClickCancel(event)} className="btn btn-default btn-primary__submit">Cancelar</button>
                                                                &nbsp;
                                                                <ButtonLoader 
                                                                    type="button"
                                                                    bloqueado={this.state.edit} 
                                                                    text="GUARDAR" 
                                                                    textProcessing="PROCESANDO..." 
                                                                    loading={this.state.loading} 
                                                                    callFunctionButton={(e) => this.callFunctionButton(e)}
                                                                ></ButtonLoader>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={1}>
                                                <div className="row ">
                                                    <div className="col-md-6">
                                                        {/* Subir imagen */}
                                                        <div className="form-group">
                                                            <label htmlFor="sFondo"><strong>Imagen Fondo Tamaño (1400 x 456)</strong></label>
                                                            <ImageUploader
                                                              onChange={this.onDrop} withIcon={true} id="Uploader"
                                                              label="Formatos aceptados: JPEG - JPG - GIF - PNG"
                                                              imgExtension={['.jpg', '.gif', '.png', '.gif']}
                                                              singleImage={true} withPreview={true}
                                                              buttonText='Click para elegir imagen'
                                                              maxFileSize={5242880} />
                                                              <button disabled={!this.state.selectedImage}
                                                                type="button" className="btn btn-primary btn-primary__tool"
                                                                onClick={this.uploadImage}>
                                                                  SUBIR Y SELECCIONAR
                                                              </button>
                                                        </div>
                                                        {/* Seleccionar imagen */}
                                                        <div className="form-group">
                                                            {/* Show thumbnail modal button */}
                                                            <button
                                                              type="button" className="btn btn-primary btn-primary__tool"
                                                              data-toggle="modal" data-target="#thumbnail-modal">
                                                                {this.state.resource.sFondo?"CAMBIAR":"SELECCIONAR DE SERVIDOR"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="boletin__filters section__margin-bottom">
                                                            {!this.state.resource.sFondo
                                                              ? (<h6>No se ha seleccionado ninguna imagen</h6>)
                                                              : (
                                                                <div>
                                                                  <img className="col-md-12"
                                                                    src={BASE_URL_RECURSOS + this.state.resource.sFondo} />
                                                                  <br/><br/>
                                                                  <button
                                                                    type="button" className="btn btn-primary btn-primary__tool"
                                                                    onClick={this.unSelectImage}>
                                                                      Eliminar
                                                                  </button>
                                                                </div>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={2}>
                                                <SeccionesBoletin clave={this.props.location.state.key} ></SeccionesBoletin>
                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={3}>
                                                <div className="row ">
                                                    <div className="col-md-12">
                                                        <div className="boletin__filters section__margin-bottom">
                                                            <strong>NUEVAS OPORTUNIDADES:</strong>
                                                            <br/><br/>
                                                            <div className="recursos__wrapper-table">
                                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{width: "10%"}}>CÓDIGO</th>
                                                                            <th style={{width: "50%"}}>TÍTULO</th>
                                                                            <th style={{width: "10%"}}>OPORTUNIDAD EMAIL</th>
                                                                            <th style={{width: "20%"}}>FECHA DE PUBLICACIÓN</th>
                                                                            <th style={{width: "10%", textAlign:"center"}}>ELIMINAR</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.addNuevasOportunidades.map((resource) => (
                                                                            <tr key={resource.nBoletinRecursoCodigo}>
                                                                                <td>{resource.nRecursoCodigo}</td>
                                                                                <td>{resource.sTituloRecurso}</td>
                                                                                <td>{((resource.bOportunidadEmail)?"Asignado":"No Asignado")}</td>
                                                                                <td>{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                                <td style={{textAlign:"center"}}>
                                                                                    <button id={"btn_"+resource.nBoletinRecursoCodigo}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleDeleteOportunity(resource.nBoletinRecursoCodigo, resource.nRecursoCodigo, resource.nBoletinRecursoCodigo)} >
                                                                                        <i id={"i_"+resource.nBoletinRecursoCodigo} className="fas fa-trash fa-sm"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <br/>
                                                            <button
                                                              disabled={this.state.edit} type="button"
                                                              className="btn btn-primary btn-primary__tool"
                                                              data-toggle="modal" data-target="#modalNuevasOportunidades"
                                                              onClick={()=>this.startPaginationClick("oportunidades")}>AGREGAR</button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={4}>
                                                <div className="row ">
                                                    <div className="col-md-12">
                                                    <div className="boletin__filters section__margin-bottom">
                                                            <strong>TENDENCIAS:</strong>
                                                            <br/><br/>
                                                            <div className="recursos__wrapper-table">
                                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{width: "10%"}} >CÓDIGO</th>
                                                                            <th style={{width: "60%"}}>TÍTULO</th>
                                                                            <th style={{width: "20%"}}>FECHA DE PUBLICACIÓN</th>
                                                                            <th style={{width: "10%", textAlign:"center"}}>ELIMINAR</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.addTendencias.map((resource) => (
                                                                            <tr key={resource.nBoletinRecursoCodigo}>
                                                                                <td>{resource.nRecursoCodigo}</td>
                                                                                <td>{resource.sTituloRecurso}</td>
                                                                                <td>{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                                <td style={{textAlign:"center"}}>
                                                                                    <button disabled={this.state.edit} id={"btn_"+resource.nBoletinRecursoCodigo}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleDeleteTrend(resource.nBoletinRecursoCodigo, resource.nRecursoCodigo, resource.nBoletinRecursoCodigo)} >
                                                                                        <i id={"i_"+resource.nBoletinRecursoCodigo} className="fas fa-trash fa-sm"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <br/>
                                                            <button
                                                              disabled={this.state.edit} type="button"
                                                              className="btn btn-primary btn-primary__tool"
                                                              data-toggle="modal" data-target="#modalTendencias"
                                                              onClick={()=>this.startPaginationClick("tendencias")}>AGREGAR</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={5}>
                                                <div className="row ">
                                                    <div className="col-md-12">
                                                        <div className="boletin__filters section__margin-bottom">
                                                            <strong>NOTICIAS:</strong>
                                                            <br/><br/>
                                                            <div className="recursos__wrapper-table">
                                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{width: "10%"}} >CÓDIGO</th>
                                                                            <th style={{width: "40%"}}>TÍTULO</th>
                                                                            <th style={{width: "10%"}}>NOTICIA PRINCIPAL</th>
                                                                            <th style={{width: "10%"}}>NOTICIA SECUNDARIA</th>
                                                                            <th style={{width: "20%"}}>FECHA DE PUBLICACIÓN</th>
                                                                            <th style={{width: "10%", textAlign:"center"}}>ELIMINAR</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.addNoticias.map((resource) => (
                                                                            <tr key={resource.nBoletinRecursoCodigo}>
                                                                                    <td>{resource.nRecursoCodigo}</td>
                                                                                    <td>{resource.sTituloRecurso}</td>
                                                                                    <td>{((resource.bNoticiaPrincipalEmail)?"Asignado":"No Asignado")}</td>
                                                                                    <td>{((resource.bNoticiaSecundariaEmail)?"Asignado":"No Asignado")}</td>
                                                                                    <td>{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                                    <td style={{textAlign:"center"}}>
                                                                                    <button disabled={this.state.edit} id={"btn_"+resource.nBoletinRecursoCodigo}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleDeleteNews(resource.nBoletinRecursoCodigo, resource.nRecursoCodigo, resource.nBoletinRecursoCodigo)} >
                                                                                        <i id={"i_"+resource.nBoletinRecursoCodigo} className="fas fa-trash fa-sm"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <br/>
                                                            <button disabled={this.state.edit} type="button"
                                                              className="btn btn-primary btn-primary__tool"
                                                              data-toggle="modal"
                                                              data-target="#modalNoticias"
                                                              onClick={()=>this.startPaginationClick("noticias")}>
                                                                AGREGAR
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={6}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="boletin__filters section__margin-bottom">
                                                            <strong>OTROS SECTORES DE INTERËS:</strong>
                                                            <br/><br/>
                                                            <div className="recursos__wrapper-table">
                                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{width: "10%"}} >CÓDIGO</th>
                                                                            <th style={{width: "60%"}}>TÍTULO</th>
                                                                            <th style={{width: "20%"}}>FECHA DE PUBLICACIÓN</th>
                                                                            <th style={{width: "10%", textAlign:"center"}}>ELIMINAR</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.addOtrosSectores.map((resource) => (
                                                                            <tr key={resource.nBoletinRecursoCodigo}>
                                                                                <td>{resource.nRecursoCodigo}</td>
                                                                                <td>{resource.sTituloRecurso}</td>
                                                                                <td>{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                                <td style={{textAlign:"center"}}>
                                                                                    <button id={"btn_"+resource.nBoletinRecursoCodigo}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleDeleteSectors(resource.nBoletinRecursoCodigo, resource.nRecursoCodigo, resource.nBoletinRecursoCodigo)} >
                                                                                        <i id={"i_"+resource.nBoletinRecursoCodigo} className="fas fa-trash fa-sm"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <br/>
                                                            <button
                                                              disabled={this.state.edit} type="button"
                                                              className="btn btn-primary btn-primary__tool"
                                                              data-toggle="modal" data-target="#modalOtrosSectores"
                                                              onClick={()=>this.startPaginationClick("otrossectores")}>AGREGAR</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={7}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="boletin__filters section__margin-bottom">
                                                            <strong>OPINIÓN Y CASOS DE ESTUDIO:</strong>
                                                            <br/><br/>
                                                            <div className="recursos__wrapper-table">
                                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{width: "10%"}}>CÓDIGO</th>
                                                                            <th style={{width: "60%"}}>TÍTULO</th>
                                                                            <th style={{width: "20%"}}>FECHA DE PUBLICACIÓN</th>
                                                                            <th style={{width: "10%", textAlign:"center"}}>ELIMINAR</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.addCasosEstudio.map((resource) => (
                                                                            <tr key={resource.nBoletinRecursoCodigo}>
                                                                                <td>{resource.nRecursoCodigo}</td>
                                                                                <td>{resource.sTituloRecurso}</td>
                                                                                <td>{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                                <td style={{textAlign:"center"}}>
                                                                                    <button id={"btn_"+resource.nBoletinRecursoCodigo}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleDeleteCases(resource.nBoletinRecursoCodigo, resource.nRecursoCodigo, resource.nBoletinRecursoCodigo)} >
                                                                                        <i id={"i_"+resource.nBoletinRecursoCodigo} className="fas fa-trash fa-sm"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <br/>
                                                            <button
                                                              disabled={this.state.edit} type="button"
                                                              className="btn btn-primary btn-primary__tool"
                                                              data-toggle="modal" data-target="#modalCasosEstudio"
                                                              onClick={()=>this.startPaginationClick("opinion")}>AGREGAR</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={8}>

                                                <div className="row ">
                                                        <div className="col-md-12">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <strong>ESTUDIOS DE MERCADO:</strong>
                                                                <br/><br/>
                                                                <div className="recursos__wrapper-table">
                                                                    <table id="recursos__table" className="table table-striped table-bordered" >
                                                                        <thead>
                                                                            <tr>
                                                                                <th style={{width: "10%"}}>CÓDIGO</th>
                                                                                <th style={{width: "50%"}}>TÍTULO</th>
                                                                                <th style={{width: "10%"}}>ESTUDIO EMAIL</th>
                                                                                <th style={{width: "20%"}}>FECHA DE PUBLICACIÓN</th>
                                                                                <th style={{width: "10%", textAlign:"center"}}>ELIMINAR</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {   this.state.addEstudiosMercado.map((resource) => (
                                                                                <tr key={resource.nBoletinRecursoCodigo}>
                                                                                    <td>{resource.nRecursoCodigo}</td>
                                                                                    <td>{resource.sTituloRecurso}</td>
                                                                                    <td>{((resource.bEstudiosEmail)?"Asignado":"No Asignado")}</td>
                                                                                    <td>{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                                    <td style={{textAlign:"center"}}>
                                                                                        <button id={"btn_"+resource.nBoletinRecursoCodigo}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleDeleteStudy(resource.nBoletinRecursoCodigo, resource.nRecursoCodigo, resource.nBoletinRecursoCodigo)} >
                                                                                            <i id={"i_"+resource.nBoletinRecursoCodigo} className="fas fa-trash fa-sm"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <br/>
                                                                <button
                                                                  disabled={this.state.edit} type="button"
                                                                  className="btn btn-primary btn-primary__tool"
                                                                  data-toggle="modal" data-target="#modalEstudiosMercado"
                                                                  onClick={()=>this.startPaginationClick("estudios")}>AGREGAR</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={9}>

                                                <div className="row ">
                                                        <div className="col-md-12">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <strong>NOTICIAS OCER:</strong>
                                                                <br/><br/>
                                                                <div className="recursos__wrapper-table">
                                                                    <table id="recursos__table" className="table table-striped table-bordered" >
                                                                        <thead>
                                                                            <tr>
                                                                                <th style={{width: "10%"}}>CÓDIGO</th>
                                                                                <th style={{width: "50%"}}>TÍTULO</th>
                                                                                <th style={{width: "10%"}}>ESTUDIO EMAIL</th>
                                                                                <th style={{width: "20%"}}>FECHA DE PUBLICACIÓN</th>
                                                                                <th style={{width: "10%", textAlign:"center"}}>ELIMINAR</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {   this.state.addOcex.map((resource) => (
                                                                                <tr key={resource.nBoletinRecursoCodigo}>
                                                                                    <td>{resource.nRecursoCodigo}</td>
                                                                                    <td>{resource.sTituloRecurso}</td>
                                                                                    <td>{((resource.bEstudiosEmail)?"Asignado":"No Asignado")}</td>
                                                                                    <td>{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                                    <td style={{textAlign:"center"}}>
                                                                                        <button id={"btn_"+resource.nBoletinRecursoCodigo}  className="btn btn-primary btn-primary__tool" type="button" onClick={(event) => this.handleDeleteOcex(resource.nBoletinRecursoCodigo, resource.nRecursoCodigo, resource.nBoletinRecursoCodigo)} >
                                                                                            <i id={"i_"+resource.nBoletinRecursoCodigo} className="fas fa-trash fa-sm"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <br/>
                                                                <button
                                                                  disabled={this.state.edit} type="button"
                                                                  className="btn btn-primary btn-primary__tool"
                                                                  data-toggle="modal" data-target="#modalOcex"
                                                                  onClick={()=>this.startPaginationClick("ocex")}>AGREGAR</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                            </TabPanel>
                                            <TabPanel value={this.state.numeroTab} index={10}>
                                                <div className="row">
                                                    <div className="col-md-12 bg-white text-center">
                                                        <br/>
                                                        <button type="button" onClick={(event)=> this.handleDownload()} className="btn btn-primary btn-primary__tool" >DESCARGAR HTML</button>
                                                        &nbsp;
                                                        <button type="button" onClick={(event)=> this.handleDownloadPdf()} className="btn btn-primary btn-primary__tool" >DESCARGAR PDF</button>

                                                        <br/>
                                                        <br/>

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 bg-white">
                                                        <span id="boletinHTML" hidden={false}>
                                                            <Mailing HTML={this.state.resource}></Mailing>
                                                        </span>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </form>

                        <div className="modal fade" id="modalNuevasOportunidades" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                        <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    </div>
                                    <div className="modal-body modal-subscription__body">
                                        <p className="modal-subscription__title">NUEVAS OPORTUNIDADES</p>

                                        <div className="row recursos__search section__margin-bottom">
                                          <div className="col-sm-12">
                                            <div className="ibox-content">
                                              <div className="search-form">
                                                <div className="input-group">
                                                  <i className="recursos__search-icon fas fa-search"></i>
                                                  <input id="oportunidades-pagination-search" type="text" placeholder="NOMBRE DEL RECURSO" name="search" data-type="search" className="recursos__search-form-control form-control input-lg" />
                                                  &nbsp;&nbsp;
                                                  <div className="input-group-btn">
                                                    <button className="btn btn-primary btn-primary__submit" onClick={() => this.searchInPagination("oportunidades")} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      BUSCAR
                                                    </button>
                                                  </div>
                                                  <div className="input-group-btn" style={{paddingLeft: "15px"}}>
                                                    <button className="btn btn-info btn-primary__submit" onClick={() => this.getResource()} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      ACTUALIZAR
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <p className="modal-subscription__info">
                                            <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: "10%"}}>#</th>
                                                            <th style={{width: "50%"}}>Título</th>
                                                            <th style={{width: "20%"}}>Fecha</th>
                                                            <th style={{width: "10%"}}>Emailing</th>
                                                            <th style={{width: "10%"}}>Agregar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {((this.state.nuevasOportunidades!==undefined)?(
                                                          this.state.page_show.map((resource) => (
                                                            <tr key={resource.nRecursoCodigo}>
                                                                <td className="text-center">{resource.nRecursoCodigo}</td>
                                                                <td className="text-left">{resource.sTituloRecurso}</td>
                                                                <td className="text-left">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                <td className="text-left">
                                                                    <Checkbox  name="bOportunidadEmail" id="bOportunidadEmail" onChange={(event) => this.handleInputChangeCheckboxOportunidades(event, resource.nRecursoCodigo, 'bOportunidadEmail')} value={resource.bOportunidadEmail} checked={resource.bOportunidadEmail} />
                                                                </td>
                                                                <td>
                                                                    {resource.bAdded?
                                                                        <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-default btn-primary__tool" type="button" disabled><i className="fas fa-check fa-sm"></i></button>
                                                                        :
                                                                        <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-primary btn-primary__tool" onClick={(event) => this.handleAddOportunity(resource.nRecursoCodigo)} type="button">
                                                                            <i id={"i_"+resource.nRecursoCodigo} className="fas fa-plus fa-sm"></i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))
                                                        ):(<tr><td colspan="3"><div className="modal-subscription__info"> No hay recursos disponibles o aprobados </div></td></tr>))}
                                                    </tbody>
                                                </table>
                                                {this.paginationTable("oportunidades")}
                                            </div>
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                            <i className="fas fa-close fa-sm"></i> &nbsp;
                                            <span>Cerrar</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="modalEstudiosMercado" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                        <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    </div>
                                    <div className="modal-body modal-subscription__body">
                                        <p className="modal-subscription__title">ESTUDIOS DE MERCADO</p>

                                        <div className="row recursos__search section__margin-bottom">
                                          <div className="col-sm-12">
                                            <div className="ibox-content">
                                              <div className="search-form">
                                                <div className="input-group">
                                                  <i className="recursos__search-icon fas fa-search"></i>
                                                  <input id="estudios-pagination-search" type="text" placeholder="NOMBRE DEL ESTUDIO" name="search" data-type="search" className="recursos__search-form-control form-control input-lg" />
                                                  &nbsp;&nbsp;
                                                  <div className="input-group-btn">
                                                    <button className="btn btn-primary btn-primary__submit" onClick={() => this.searchInPagination("estudios")} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      BUSCAR
                                                    </button>
                                                  </div>
                                                  <div className="input-group-btn" style={{paddingLeft: "15px"}}>
                                                    <button className="btn btn-info btn-primary__submit" onClick={() => this.getResource()} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      ACTUALIZAR
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <p className="modal-subscription__info">
                                            <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: "10%"}}>#</th>
                                                            <th style={{width: "50%"}}>Título</th>
                                                            <th style={{width: "20%"}}>Fecha</th>
                                                            <th style={{width: "10%"}}>Emailing</th>
                                                            <th style={{width: "10%"}}>Agregar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {((this.state.estudiosMercado!==undefined)?(
                                                        this.state.page_show.map((resource) => (
                                                            <tr key={resource.nRecursoCodigo}>
                                                                <td className="text-center">{resource.nRecursoCodigo}</td>
                                                                <td className="text-left">{resource.sTituloRecurso}</td>
                                                                <td className="text-left">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                <td className="text-left">
                                                                    <Checkbox  name="bEstudiosEmail" id="bEstudiosEmail" onChange={(event) => this.handleInputChangeCheckbox(event, resource.nRecursoCodigo, 'bEstudiosEmail')} value={resource.bEstudiosEmail} checked={resource.bEstudiosEmail} />
                                                                </td>
                                                                <td>
                                                                    {resource.bAdded?
                                                                        <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-default btn-primary__tool" type="button" disabled><i className="fas fa-check fa-sm"></i></button>
                                                                        :
                                                                        <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-primary btn-primary__tool" onClick={(event) => this.handleAddStudy(resource.nRecursoCodigo)} type="button">
                                                                            <i id={"i_"+resource.nRecursoCodigo} className="fas fa-plus fa-sm"></i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))
                                                        ):(<tr><td colspan="3"><div className="modal-subscription__info"> No hay recursos disponibles o aprobados </div></td></tr>))}
                                                    </tbody>
                                                </table>
                                                {this.paginationTable("estudios")}
                                            </div>
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button id="btn_addTendencia" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                            <i id="i_addTendencia" className="fas fa-close fa-sm"></i> &nbsp;
                                            <span>Cerrar</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="modalNoticias" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                        <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    </div>
                                    <div className="modal-body modal-subscription__body">
                                        <p className="modal-subscription__title">NOTICIAS</p>

                                        <div className="row recursos__search section__margin-bottom">
                                          <div className="col-sm-12">
                                            <div className="ibox-content">
                                              <div className="search-form">
                                                <div className="input-group">
                                                  <i className="recursos__search-icon fas fa-search"></i>
                                                  <input id="noticias-pagination-search" type="text" placeholder="NOMBRE DEL RECURSO" name="search" data-type="search" className="recursos__search-form-control form-control input-lg" />
                                                  &nbsp;&nbsp;
                                                  <div className="input-group-btn">
                                                    <button className="btn btn-primary btn-primary__submit" onClick={() => this.searchInPagination("noticias")} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      BUSCAR
                                                    </button>
                                                  </div>
                                                  <div className="input-group-btn" style={{paddingLeft: "15px"}}>
                                                    <button className="btn btn-info btn-primary__submit" onClick={() => this.getResource()} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      ACTUALIZAR
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <p className="modal-subscription__info">
                                            <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: "10%"}}>#</th>
                                                            <th style={{width: "50%"}}>Título</th>
                                                            <th style={{width: "20%"}}>Fecha</th>
                                                            <th style={{width: "10%"}}>E. Principal</th>
                                                            <th style={{width: "10%"}}>E. Secundario</th>
                                                            <th style={{width: "10%"}}>Agregar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.page_show.map((resource) => (
                                                            <tr key={resource.nRecursoCodigo}>
                                                                <td className="text-center">{resource.nRecursoCodigo}</td>
                                                                <td className="text-left">{resource.sTituloRecurso}</td>
                                                                <td className="text-left">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                <td className="text-left">
                                                                    <Checkbox  name="bNoticiaPrincipalEmail" id="bNoticiaPrincipalEmail" onChange={(event) => this.handleInputChangeCheckboxNoticias(event, resource.nRecursoCodigo, 'bNoticiaPrincipalEmail')} value={resource.bNoticiaPrincipalEmail} checked={resource.bNoticiaPrincipalEmail} />
                                                                </td>
                                                                <td className="text-left">
                                                                    <Checkbox  name="bNoticiaSecundariaEmail" id="bNoticiaSecundariaEmail" onChange={(event) => this.handleInputChangeCheckboxNoticias(event, resource.nRecursoCodigo, 'bNoticiaSecundariaEmail')} value={resource.bNoticiaSecundariaEmail} checked={resource.bNoticiaSecundariaEmail} />
                                                                </td>
                                                                <td>
                                                                    {resource.bAdded?
                                                                        <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-default btn-primary__tool" type="button" disabled><i className="fas fa-check fa-sm"></i></button>
                                                                        :
                                                                        <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-primary btn-primary__tool" onClick={(event) => this.handleAddNews(resource.nRecursoCodigo)} type="button">
                                                                            <i id={"i_"+resource.nRecursoCodigo} className="fas fa-plus fa-sm"></i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {this.paginationTable("noticias")}
                                            </div>
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                            <i className="fas fa-close fa-sm"></i> &nbsp;
                                            <span>Cerrar</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="modalOtrosSectores" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                        <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    </div>
                                    <div className="modal-body modal-subscription__body">
                                        <p className="modal-subscription__title">OTROS SECTORES DE INTERÉS</p>

                                        <div className="row recursos__search section__margin-bottom">
                                          <div className="col-sm-12">
                                            <div className="ibox-content">
                                              <div className="search-form">
                                                <div className="input-group">
                                                  <i className="recursos__search-icon fas fa-search"></i>
                                                  <input id="otrossectores-pagination-search" type="text" placeholder="NOMBRE DEL SECTOR" name="search" data-type="search" className="recursos__search-form-control form-control input-lg" />
                                                  &nbsp;&nbsp;
                                                  <div className="input-group-btn">
                                                    <button className="btn btn-primary btn-primary__submit" onClick={() => this.searchInPagination("otrossectores")} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      BUSCAR
                                                    </button>
                                                  </div>
                                                  <div className="input-group-btn" style={{paddingLeft: "15px"}}>
                                                    <button className="btn btn-info btn-primary__submit" onClick={() => this.getResource()} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      ACTUALIZAR
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <p className="modal-subscription__info">
                                            <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: "10%"}}>CÓDIGO</th>
                                                            <th style={{width: "60%"}}>TÍTULO</th>
                                                            <th style={{width: "20%"}}>FECHA</th>
                                                            <th style={{width: "10%"}}>AGREGAR</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.page_show.map((resource) => (
                                                            <tr key={resource.nRecursoCodigo}>
                                                                <td className="text-center">{resource.nRecursoCodigo}</td>
                                                                <td className="text-left">{resource.sTituloRecurso}</td>
                                                                <td className="text-left">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                <td>
                                                                {resource.bAdded?
                                                                    <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-default btn-primary__tool" type="button" disabled><i className="fas fa-check fa-sm"></i></button>
                                                                    :
                                                                    <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-primary btn-primary__tool" onClick={(event) => this.handleAddSector(resource.nRecursoCodigo)} type="button">
                                                                        <i id={"i_"+resource.nRecursoCodigo} className="fas fa-plus fa-sm"></i>
                                                                    </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {this.paginationTable("otrossectores")}
                                            </div>
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button id="btn_addTendencia" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                            <i id="i_addTendencia" className="fas fa-close fa-sm"></i> &nbsp;
                                            <span>Cerrar</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="modalCasosEstudio" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                        <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    </div>
                                    <div className="modal-body modal-subscription__body">
                                        <p className="modal-subscription__title">OPINIÓN Y CASOS DE ESTUDIO</p>

                                        <div className="row recursos__search section__margin-bottom">
                                          <div className="col-sm-12">
                                            <div className="ibox-content">
                                              <div className="search-form">
                                                <div className="input-group">
                                                  <i className="recursos__search-icon fas fa-search"></i>
                                                  <input id="opinion-pagination-search" type="text" placeholder="NOMBRE DE LA OPINION" name="search" data-type="search" className="recursos__search-form-control form-control input-lg" />
                                                  &nbsp;&nbsp;
                                                  <div className="input-group-btn">
                                                    <button className="btn btn-primary btn-primary__submit" onClick={() => this.searchInPagination("opinion")} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      BUSCAR
                                                    </button>
                                                  </div>
                                                  <div className="input-group-btn" style={{paddingLeft: "15px"}}>
                                                    <button className="btn btn-info btn-primary__submit" onClick={() => this.getResource()} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      ACTUALIZAR
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <p className="modal-subscription__info">
                                            <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: "10%"}}>CÓDIGO</th>
                                                            <th style={{width: "60%"}}>TÍTULO</th>
                                                            <th style={{width: "20%"}}>FECHA</th>
                                                            <th style={{width: "10%"}}>AGREGAR</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.page_show.map((resource) => (
                                                            <tr key={resource.nRecursoCodigo}>
                                                                <td className="text-center">{resource.nRecursoCodigo}</td>
                                                                <td className="text-left">{resource.sTituloRecurso}</td>
                                                                <td className="text-left">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                <td>
                                                                {resource.bAdded?
                                                                    <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-default btn-primary__tool" type="button" disabled><i className="fas fa-check fa-sm"></i></button>
                                                                    :
                                                                    <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-primary btn-primary__tool" onClick={(event) => this.handleAddCases(resource.nRecursoCodigo)} type="button">
                                                                        <i id={"i_"+resource.nRecursoCodigo} className="fas fa-plus fa-sm"></i>
                                                                    </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {this.paginationTable("opinion")}
                                            </div>
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button id="btn_addTendencia" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                            <i id="i_addTendencia" className="fas fa-close fa-sm"></i> &nbsp;
                                            <span>Cerrar</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id="modalTendencias" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                        <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body modal-subscription__body">
                                        <p className="modal-subscription__title">TENDENCIAS</p>

                                        <div className="row recursos__search section__margin-bottom">
                                          <div className="col-sm-12">
                                            <div className="ibox-content">
                                              <div className="search-form">
                                                <div className="input-group">
                                                  <i className="recursos__search-icon fas fa-search"></i>
                                                  <input id="tendencias-pagination-search" type="text" placeholder="NOMBRE DEL RECURSO" name="search" data-type="search" className="recursos__search-form-control form-control input-lg" />
                                                  &nbsp;&nbsp;
                                                  <div className="input-group-btn">
                                                    <button className="btn btn-primary btn-primary__submit" onClick={() => this.searchInPagination("tendencias")} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      BUSCAR
                                                    </button>
                                                  </div>
                                                  <div className="input-group-btn" style={{paddingLeft: "15px"}}>
                                                    <button className="btn btn-info btn-primary__submit" onClick={() => this.getResource()} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      ACTUALIZAR
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="modal-subscription__info">
                                            <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: "10%"}}>CÓDIGO</th>
                                                            <th style={{width: "60%"}}>TÍTULO</th>
                                                            <th style={{width: "20%"}}>FECHA</th>
                                                            <th style={{width: "10%"}}>AGREGAR</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.page_show.map((resource) => (
                                                            <tr key={resource.nRecursoCodigo}>
                                                                <td className="text-center">{resource.nRecursoCodigo}</td>
                                                                <td className="text-left">{resource.sTituloRecurso}</td>
                                                                <td className="text-left">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                <td>
                                                                {resource.bAdded?
                                                                    <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-default btn-primary__tool" type="button" disabled><i className="fas fa-check fa-sm"></i></button>
                                                                    :
                                                                    <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-primary btn-primary__tool" onClick={(event) => this.handleAddTrend(resource.nRecursoCodigo)} type="button">
                                                                        <i id={"i_"+resource.nRecursoCodigo} className="fas fa-plus fa-sm"></i>
                                                                    </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {this.paginationTable("tendencias")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                      <button type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                        <i className="fas fa-close fa-sm"></i> &nbsp;
                                        <span>Cerrar</span>
                                      </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal fade" id="modalOcex" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                        <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body modal-subscription__body">
                                        <p className="modal-subscription__title">NOTICIAS OCER</p>

                                        <div className="row recursos__search section__margin-bottom">
                                          <div className="col-sm-12">
                                            <div className="ibox-content">
                                              <div className="search-form">
                                                <div className="input-group">
                                                  <i className="recursos__search-icon fas fa-search"></i>
                                                  <input id="tendencias-pagination-search" type="text" placeholder="NOMBRE DEL RECURSO" name="search" data-type="search" className="recursos__search-form-control form-control input-lg" />
                                                  &nbsp;&nbsp;
                                                  <div className="input-group-btn">
                                                    <button className="btn btn-primary btn-primary__submit" onClick={() => this.searchInPagination("ocex")} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      BUSCAR
                                                    </button>
                                                  </div>
                                                  <div className="input-group-btn" style={{paddingLeft: "15px"}}>
                                                    <button className="btn btn-info btn-primary__submit" onClick={() => this.getResource()} type="submit">
                                                      <i className="fa fa-search" style={{ marginRight: "8px" }} />
                                                      ACTUALIZAR
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="modal-subscription__info">
                                            <div className="recursos__wrapper-table">
                                                <table id="recursos__table" className="table table-striped table-bordered" >
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: "10%"}}>CÓDIGO</th>
                                                            <th style={{width: "60%"}}>TÍTULO</th>
                                                            <th style={{width: "20%"}}>FECHA</th>
                                                            <th style={{width: "10%"}}>AGREGAR</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.page_show.map((resource) => (
                                                            <tr key={resource.nRecursoCodigo}>
                                                                <td className="text-center">{resource.nRecursoCodigo}</td>
                                                                <td className="text-left">{resource.sTituloRecurso}</td>
                                                                <td className="text-left">{Moment(resource.dFechaPublicacionRecurso).format('DD/MM/YYYY')}</td>
                                                                <td>
                                                                {resource.bAdded?
                                                                    <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-default btn-primary__tool" type="button" disabled><i className="fas fa-check fa-sm"></i></button>
                                                                    :
                                                                    <button id={"btn_"+resource.nRecursoCodigo} className="btn btn-primary btn-primary__tool" onClick={(event) => this.handleAddOcex(resource.nRecursoCodigo)} type="button">
                                                                        <i id={"i_"+resource.nRecursoCodigo} className="fas fa-plus fa-sm"></i>
                                                                    </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {this.paginationTable("ocex")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                      <button type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                        <i className="fas fa-close fa-sm"></i> &nbsp;
                                        <span>Cerrar</span>
                                      </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Thumbnail MODAL */}

                        <div className="modal fade" id="thumbnail-modal" tabIndex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                          <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>

                              <div className="modal-body modal-subscription__body">
                                <p className="modal-subscription__title">Imagenes</p>

                                <p className="modal-subscription__info">
                                  <div className="recursos__wrapper-table">
                                    {/* Content */}
                                    {this.state.imagesToSelect
                                      ? <ThumbnailGrid
                                          selectImage={this.selectImage}
                                          img_links={this.state.imagesToSelect}
                                          changePage={this.getImages}
                                          sizeX={"150px"} sizeY={"150px"} />
                                      : <InComponentLoader show={true} message={"Se está generando el Boletín HTML espere un momento"} />
                                    }
                                  </div>
                                </p>
                                {this.imagePaginationTable()}
                              </div>

                              <div className="modal-footer">
                                <button id="thumbnail-modal-close" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                  <i className="fas fa-close fa-sm"></i> &nbsp;
                                  <span>Cerrar</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                )
                :
                (
                    <Error StatusCode="500" StatusMessage="Error"></Error>
                )
                );
    }
}
